<template>
  <div class="page-col">
    <div class="page-main">
      <!-- Header Premium -->
      <div class="list-header-premium d-flex flex-column flex-md-row align-items-center justify-content-between gap-3 p-0 mb-2" :class="{'bg-dark border-secondary': isDark}">
        <div class="d-flex align-items-center py-1 px-3 flex-shrink-0">
          <div class="header-icon-wrapper mr-3 ml-2" style="background: linear-gradient(135deg, #11998e 0%, #38ef7d 100%);">
            <i class="fa fa-cogs text-white"></i>
          </div>
          <div>
            <h4 class="mb-0 font-weight-bold" :class="isDark ? 'text-white' : 'text-dark'" style="font-size: 1.15rem;">Tipos de Beneficiamento</h4>
            <small class="text-muted small">Gerenciamento de tipos de beneficiamento</small>
          </div>
        </div>

        <div class="d-flex align-items-center flex-wrap gap-2 py-1 px-3 w-100 w-md-auto justify-content-end">
            <!-- Search Pill -->
            <div class="search-pill-responsive d-flex align-items-center bg-light rounded-pill p-1 shadow-xs border mr-2">
                <b-button-group class="mr-2 d-none d-lg-inline-flex">
                    <b-button variant="link" class="btn-icon-only text-muted" @click="exportarExcel()" v-b-tooltip.hover title="Exportar Excel">
                        <i class="fa fa-file-excel-o"></i>
                    </b-button>
                    <b-button variant="link" class="btn-icon-only text-muted" @click="exportarHtml()" v-b-tooltip.hover title="Imprimir Listagem">
                        <i class="fa fa-print"></i>
                    </b-button>
                    <b-button variant="link" class="btn-icon-only text-danger" @click="limparFiltro()" v-b-tooltip.hover title="Limpar Filtros">
                        <i class="fa fa-ban"></i>
                    </b-button>
                </b-button-group>

                <b-button-group class="mr-2 d-lg-none">
                    <b-button variant="link" class="btn-icon-only text-danger" @click="limparFiltro()" v-b-tooltip.hover title="Limpar">
                        <i class="fa fa-ban"></i>
                    </b-button>
                </b-button-group>

                <div class="d-flex align-items-center px-2 border-left mr-2">
                    <div style="min-width: 130px" class="mr-2">
                        <b-form-select 
                            v-model="situacaoFiltro" 
                            class="shadow-xs" 
                            style="font-size: 0.9rem;"
                            @change="pesquisar()">
                            <b-form-select-option value="">Todos</b-form-select-option>
                            <b-form-select-option value="1">Ativos</b-form-select-option>
                            <b-form-select-option value="0">Inativos</b-form-select-option>
                        </b-form-select>
                    </div>
                    <div style="min-width: 150px" class="mr-2">
                        <b-form-select 
                            v-model="opTipoFiltro" 
                            class="shadow-xs" 
                            style="font-size: 0.9rem;"
                            @change="pesquisar()">
                            <b-form-select-option value="">Todos os Tipos</b-form-select-option>
                            <b-form-select-option value="P">Produção</b-form-select-option>
                            <b-form-select-option value="D">Desossa</b-form-select-option>
                            <b-form-select-option value="M">Carne Moída</b-form-select-option>
                            <b-form-select-option value="C">Charcaria</b-form-select-option>
                            <b-form-select-option value="Q">Quarteio</b-form-select-option>
                        </b-form-select>
                    </div>
                    <div style="min-width: 250px">
                        <b-form-input 
                            v-model="textoPesquisa" 
                            placeholder="Buscar por descrição..."
                            class="shadow-xs" 
                            style="font-size: 0.9rem;"
                            @keydown.enter.native="pesquisar()">
                        </b-form-input>
                    </div>
                </div>
                <b-button variant="primary" pill class="px-4 font-weight-bold shadow-sm text-white btn-filtrar-responsive" :disabled="isBusy" @click="pesquisar()">
                    <i class="fa fa-search mr-1"></i> <span class="d-none d-sm-inline">FILTRAR</span>
                </b-button>
            </div>

            <!-- Action Buttons -->
            <b-button variant="success" pill class="px-4 font-weight-bold shadow-sm btn-adicionar-responsive" @click.stop.prevent="novo()">
              <i class="fa fa-plus-circle mr-1"></i>
              <span class="d-none d-sm-inline">Novo Tipo</span>
            </b-button>
        </div>
      </div>

      <!--/.row-->
      <b-row class="ml-0 mr-0 p-0" :class="isDark ? 'bg-dark' : 'bg-white'">
        <b-col sm="12" class="px-2">
          <div class="bg-white rounded border shadow-sm overflow-hidden">
            <b-table 
                    ref="tbl"
                    class="mb-0 table-finance"
                    :head-variant="isDark ? 'dark' : 'light'"
                    :dark="isDark"
                    show-empty
                    empty-text="Nenhum tipo de beneficiamento encontrado"
                    responsive 
                    :sticky-header="stickyHeight"
                    hover 
                    small
                    :busy.sync="isBusy" 
                    :items="itensFiltrados" 
                    :fields="colunas"
                    :current-page="currentPage"
                    @row-clicked="clicarLinha"
                    :per-page="perPage"
                    @row-dblclicked="edit"
                    :tbody-tr-class="rowClassSelecionado"    
                    >
                  
              <template #head(ID)>
                <SetFilter label="ID" v-model="filtros.ID" :options="opcoes.ID" :normalizeFn="normalize" :dropdown-variant="isDark ? 'dark' : 'none'" />
              </template>
              <template #head(DESCRICAO)>
                <SetFilter label="Descrição" v-model="filtros.DESCRICAO" :options="opcoes.DESCRICAO" :normalizeFn="normalize" :dropdown-variant="isDark ? 'dark' : 'none'" />
              </template>
              <template #head(OP_TIPO)>
                <SetFilter label="Tipo Op." v-model="filtros.OP_TIPO" :options="opcoes.OP_TIPO" :normalizeFn="normalize" :dropdown-variant="isDark ? 'dark' : 'none'" />
              </template>
              <template #head(SITUACAO)>
                <SetFilter label="Situação" v-model="filtros.SITUACAO" :options="opcoes.SITUACAO" :normalizeFn="normalize" :dropdown-variant="isDark ? 'dark' : 'none'" />
              </template>
              
              <template #empty>
                <div class="h-100 d-flex align-items-center justify-content-center">
                  Nenhum registro encontrado
                </div>
              </template>
              
              <template #cell(actions)="item">
                <div class="d-flex justify-content-center gap-1">
                  <b-button type="button" @click.stop.prevent="edit(item.item)" variant="soft-primary" pill class="btn-icon-only shadow-sm" title="Editar" v-b-tooltip.hover>
                    <i class="fa fa-pencil"></i>
                  </b-button>
                  <b-button type="button" @click.stop.prevent="abrirModalExcluir(item.item)" variant="soft-danger" pill class="btn-icon-only shadow-sm" title="Excluir" v-b-tooltip.hover>
                    <i class="fa fa-trash"></i>
                  </b-button>
                </div>
              </template>

              <template #cell(ID)="row">
                <span class="font-weight-bold text-primary">{{ row.item.ID }}</span>
              </template>

              <template #cell(OP_TIPO)="row">
                <b-badge :variant="getOpTipoVariant(row.item.OP_TIPO)">
                  {{ getOpTipoLabel(row.item.OP_TIPO) }}
                </b-badge>
              </template>

              <template #cell(SITUACAO)="row">
                <b-badge :variant="row.item.SITUACAO === '1' ? 'success' : 'danger'">
                  {{ row.item.SITUACAO === '1' ? 'Ativo' : 'Inativo' }}
                </b-badge>
              </template>
            </b-table>
          </div>

          <!-- Paginação -->
          <div class="d-flex justify-content-between align-items-center mt-3 px-1">
            <div class="small text-muted">
              <span v-if="!filtroAtivo">Nenhum filtro aplicado</span>
              <span v-else>
                <i class="fa fa-filter text-primary"></i> Filtros ativos
              </span>
            </div>
            <div class="d-flex align-items-center">
              <b-pagination
                v-model="currentPage"
                :total-rows="totalRows"
                :per-page="perPage"
                size="sm"
                class="mb-0"
                first-number
                last-number
              ></b-pagination>
              <div class="ml-3">
                <b-form-select 
                  v-model="perPage" 
                  :options="[10, 25, 50, 100]" 
                  size="sm" 
                  style="width: 80px;">
                  <template #first>
                    <b-form-select-option :value="perPage">{{ perPage }}/página</b-form-select-option>
                  </template>
                </b-form-select>
              </div>
            </div>
          </div>
        </b-col>
      </b-row>
    </div>

    <!-- Modal de Exclusão -->
    <b-modal ref="modalExcluir" title="Confirmar Exclusão" ok-title="Confirmar" cancel-title="Cancelar" ok-variant="danger" @ok="excluir">
      <div class="d-block">
        <p class="font-weight-bold">Tem certeza que deseja excluir este tipo de beneficiamento?</p>
        <div v-if="itemExcluir" class="bg-light p-3 rounded">
          <p class="mb-1"><strong>ID:</strong> {{ itemExcluir.ID }}</p>
          <p class="mb-0"><strong>Descrição:</strong> {{ itemExcluir.DESCRICAO }}</p>
        </div>
      </div>
    </b-modal>
  </div>
</template>

<script>
import SetFilter from '@/components/Cec/SetFilter.vue'
import { createCecTableToolsMixin } from '@/mixins/cecTableTools'
import { mapGetters } from 'vuex'
import { printHtmlReport, exportExcelXlsx } from '@/utils/RelatorioHTML'

export default {
  components: { 
    SetFilter
  },
  mixins: [createCecTableToolsMixin({ rowsProp: 'lista', tblRef: 'tbl', useExternalPaging: false, filters: [
    { key: 'ID', type: 'number', label: 'ID' },
    { key: 'DESCRICAO', type: 'string', label: 'Descrição' },
    { key: 'OP_TIPO', type: 'string', label: 'Tipo Op.' },
    { key: 'SITUACAO', type: 'string', label: 'Situação' }
  ] })],

  data() {
    return {
      isBusy: false,
      itemExcluir: null,
      situacaoFiltro: '1',
      opTipoFiltro: '',
      colunas: [
        { key: 'ID', label: 'ID', sortable: true, class: 'text-center', thStyle: { width: '100px' } },
        { key: 'DESCRICAO', label: 'Descrição', sortable: true },
        { key: 'OP_TIPO', label: 'Tipo Operação', sortable: true, class: 'text-center', thStyle: { width: '150px' } },
        { key: 'SITUACAO', label: 'Situação', sortable: true, class: 'text-center', thStyle: { width: '120px' } },
        { key: 'actions', label: 'Ações', class: 'text-center', thStyle: { width: '120px' } }
      ]
    }
  }, 

  computed: {
    isDark() { return this.$store.getters['tema/IS_DARK'] },
    ...mapGetters('tipoBeneficiamento', ['lista', 'textoPesquisa', 'situacao', 'opTipo', 'registroSelecionadoId', 'recarregarLista'])
  },

  watch: {
    situacaoFiltro(newVal) {
      this.$store.commit('tipoBeneficiamento/SET_SITUACAO', newVal)
    },
    opTipoFiltro(newVal) {
      this.$store.commit('tipoBeneficiamento/SET_OP_TIPO', newVal)
    }
  },

  methods: {
    clicarLinha(item) { 
      this.$store.commit('tipoBeneficiamento/SET_REGISTRO_SELECIONADO_ID', item.ID) 
    },
    
    rowClassSelecionado(item, type) { 
      if (type !== 'row' || !item) return ''
      return item.ID === this.registroSelecionadoId ? 'cec-row-selected' : ''
    },
    
    scrollToSelected() {
      this.$nextTick(() => {
        setTimeout(() => {
          const el = document.querySelector('.cec-row-selected')
          if (el) {
            el.scrollIntoView({ behavior: 'smooth', block: 'center' })
          }
        }, 500)
      })
    },

    getOpTipoLabel(tipo) {
      const tipos = {
        'P': 'Produção',
        'D': 'Desossa',
        'M': 'Carne Moída',
        'C': 'Charcaria',
        'Q': 'Quarteio'
      }
      return tipos[tipo] || tipo
    },

    getOpTipoVariant(tipo) {
      const variants = {
        'P': 'primary',
        'D': 'info',
        'M': 'warning',
        'C': 'success',
        'Q': 'secondary'
      }
      return variants[tipo] || 'secondary'
    },

    limparFiltro() {
      this.$store.commit('tipoBeneficiamento/SET_LIMPAR')
      this.situacaoFiltro = '1'
      this.opTipoFiltro = ''
      this.pesquisar()
    },

    novo() {
      this.$router.push('/cadastros/tipo-beneficiamento/add')
    },

    edit(item) {
      if (!item || !item.ID) return
      this.$store.commit('tipoBeneficiamento/SET_REGISTRO_SELECIONADO_ID', item.ID)
      this.$router.push(`/cadastros/tipo-beneficiamento/edit/${item.ID}`)
    },

    async pesquisar() {
      try {
        this.$store.commit('controle/setAguardando', true)
        this.isBusy = true
        
        await this.$store.dispatch('tipoBeneficiamento/GET_LISTA')

        if (this.registroSelecionadoId) {
          this.scrollToSelected()
        }

      } catch (err) {
        console.error('Erro ao pesquisar Tipo de Beneficiamento:', err)
        this.$bvToast.toast('Erro ao pesquisar registros', { title: 'Erro', variant: 'danger' })
      } finally {
        this.isBusy = false
        this.$store.commit('controle/setAguardando', false)
      }
    },

    abrirModalExcluir(item) {
      this.itemExcluir = item
      this.$refs.modalExcluir.show()
    },

    async excluir() {
      if (!this.itemExcluir) return

      try {
        this.$store.commit('controle/setAguardando', true)
        
        await this.$http.post('/api/protected/tipo/beneficiamento/delete', {
          ID: this.itemExcluir.ID
        })
        
        this.$bvToast.toast('Registro excluído com sucesso', { title: 'Sucesso', variant: 'success' })
        this.itemExcluir = null
        this.pesquisar()

      } catch (err) {
        console.error('Erro ao excluir Tipo de Beneficiamento:', err)
        this.$bvToast.toast('Erro ao excluir registro', { title: 'Erro', variant: 'danger' })
      } finally {
        this.$store.commit('controle/setAguardando', false)
      }
    },

    exportarHtml() { 
      printHtmlReport({ 
        rows: this.lista, 
        columns: this.colunas, 
        systemName: 'CECWeb', 
        reportTitle: 'Listagem de Tipos de Beneficiamento', 
        printedBy: window.localStorage.getItem('login') ?? '—' 
      }) 
    },
    
    exportarExcel() { 
      exportExcelXlsx({ 
        rows: this.lista, 
        columns: this.colunas, 
        filename: 'tipo-beneficiamento-lista.xlsx' 
      }) 
    }
  },

  async created() {
    // Sincroniza o status do store com os filtros locais
    this.situacaoFiltro = this.situacao || '1'
    this.opTipoFiltro = this.opTipo || ''
    
    if (this.recarregarLista || !this.lista || this.lista.length === 0) {
      this.$store.commit('tipoBeneficiamento/SET_RECARREGAR_LISTA', false)
      await this.pesquisar()
    } else {
      if (this.registroSelecionadoId) {
        this.$nextTick(() => {
          this.scrollToSelected()
        })
      }
    }
  }
}
</script>

<style lang="scss" scoped>
/* Scoped styles if needed */
</style>



// WEBPACK FOOTER //
// src/views/cadastros/tipo-beneficiamento/TipoBeneficiamentoListagem.vue